import api from '../lib/axios';
import { downloadFile } from '../lib/download';
export async function getDatasets() {
    const { data } = await api.get('/api/admin/datasets');
    return data.data;
}
export async function getDataset(id) {
    const { data } = await api.get(`/api/admin/datasets/${id}`);
    return data.data;
}
export async function createDataset(body) {
    const { data } = await api.post('/api/admin/datasets', body);
    return data.data;
}
/** A 409 with code "confirm_field_removal" means removed fields hold data: resend with confirm_field_removal. */
export async function updateDataset(id, body) {
    const { data } = await api.patch(`/api/admin/datasets/${id}`, body);
    return data.data;
}
export async function deleteDataset(id) {
    await api.delete(`/api/admin/datasets/${id}`);
}
export async function importDatasetFile(id, file) {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await api.post(`/api/admin/datasets/${id}/import`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
}
export async function downloadDatasetTemplate(id, name, format) {
    // Content-Disposition is not exposed by CORS: the fallback name is the one used.
    const base = name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'donnees';
    await downloadFile(`/api/admin/datasets/${id}/template`, `${base}-modele.${format}`, { format });
}
export async function getDatasetItems(id, page = 1) {
    const { data } = await api.get(`/api/admin/datasets/${id}/items`, { params: { page } });
    return data;
}
export async function previewDataset(id, blocks, itemId) {
    const { data } = await api.post(`/api/admin/datasets/${id}/preview`, {
        blocks,
        item_id: itemId,
    });
    return data.data;
}
/** Server error message from an axios error, if any. */
export function apiError(e) {
    const res = e?.response;
    return { ...(res?.data ?? {}), status: res?.status };
}
